<div class="container" *ngIf="finishedLoading">
    <div class="row">
        <div class="col-sm-12">
            <h4>Paramter</h4>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-12">

            <div class="row" style="margin-top: 35px;">
                <div class="col-lg-12 marginBottom2Rem">
                    <mat-card appearance="outlined" class="example-card">
                        <mat-card-content>
                            <mat-card-title>Paramterkonfiguration</mat-card-title>
                            <div class="row" *ngFor="let p of clientConfiguration; let i = index" style="align-items: center; margin-bottom: 20px;">
                                <div class="col-lg-10">
                                    <mat-form-field class="full-width">
                                        <mat-label>{{ p.displayName }}</mat-label>
                                        <input matInput class="full-width" [(ngModel)]="p.value"
                                            (input)="p.changed = true;">
                                        <mat-hint>{{p.description !== "" ? p.description: ""}}</mat-hint>
                                    </mat-form-field>
                                </div>
                                <div class="col-lg-2">
                                    <button mat-button color="primary" (click)="saveProperty(p)"
                                        [disabled]="!p.changed">
                                        Speichern
                                    </button>
                                </div>
                            </div>
                        </mat-card-content>
                    </mat-card>
                </div>
            </div>
        </div>
    </div>
</div>




<div class="container" *ngIf="!finishedLoading">
    <div class="row">
        <div class="col-sm-12 padding">
            <div class="loadingOverlay">
                <mat-spinner></mat-spinner>
            </div>
        </div>
    </div>
</div>